import { LinkStylesStructure } from '@pijma/hero-types'

export const LinkBaseStyles: LinkStylesStructure['styleProvider'] = {
  root: (props) => ({
    cursor: props.disabled ? 'default' : 'pointer',
    pointerEvents: props.disabled ? 'none' : 'auto',
  }),
}
